const React = require('react');

const Close = require('@pages/V2/icons/close');

const { FILTERS_IDS } = require('@pages/V2/utils/constants');
const { buildUrl } = require('@pages/V2/utils/clientUtils');

const NOT_SHOW_PILL_FILTER = [FILTERS_IDS.CATEGORY, FILTERS_IDS.SHIPPING, FILTERS_IDS.SHIPPING_TIME];

const AppliedFilters = ({ appliedFilters, actualLocation }) => {
  return (
    <div className="qcat-applied-filters">
      {appliedFilters
        ?.filter((filter) => !NOT_SHOW_PILL_FILTER.includes(filter.id))
        .map(({ id, values }) => {
          return (
            <a
              key={id}
              className="qcat-applied-filters__filter"
              href={buildUrl({ actualLocation, filterId: id, addQueryParam: false })}
            >
              <span>{values[0].name}</span>
              <Close className="qcat-applied-filters__close-icon" />
            </a>
          );
        })}
    </div>
  );
};

module.exports = AppliedFilters;
